import { userLanguage, ValidLanguages } from '$translations/index';
import { ErrorMessageEn, ErrorMessageEs } from '../../../../constants/alerts';
import { errorHandler } from '../../../utils';
import {
  GetAllLanguagesOutput,
  LanguageBuilder,
  LanguageDto,
} from '../language.types';

export const getAllLanguages = (builder: LanguageBuilder) =>
  builder.query<GetAllLanguagesOutput, void>({
    query: () => ({
      url: `/languages`,
      method: 'GET',
    }),
    transformResponse: (response: LanguageDto[]) => {
      return response;
    },
    transformErrorResponse: (error) => {
      errorHandler(
        '[getAllLanguages]',
        userLanguage === ValidLanguages.es
          ? ErrorMessageEs.LanguageError
          : ErrorMessageEn.LanguageError,
        error,
        true
      );
      return error.data;
    },
  });
